(function() { module.exports = window["eventespresso"]["toaster"]; }());